import { render, staticRenderFns } from "./RestaurantsModule.vue?vue&type=template&id=2e20f1e0&scoped=true"
import script from "./RestaurantsModule.vue?vue&type=script&lang=js"
export * from "./RestaurantsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20f1e0",
  null
  
)

export default component.exports